module.exports = __webpack_public_path__ + "img/environment1.b010fc7a.jpg";